import { Component } from '@angular/core';

@Component({
  selector: 'procure-page-body',
  templateUrl: './page-body.component.html',
  styleUrl: './page-body.component.scss',
})
export class PageBody {}
